import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as React from "react";

import {
  MenuItem,
  ListItemIcon,
  IconButton,
  Power,
} from "mpulse-design-system";
import { Logout } from "@mui/icons-material";
import { Box, Menu } from "@mui/material";

import { useAuth } from "../../hooks/useAuth";
import { AUTH_API_LOGOUT } from "../../redux/user/actionTypes";

const LogoutButton = (props) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null),
    { logout } = useAuth(),
    navigate = useNavigate();

  const openMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    logout().then(() => {
      navigate("/login", { replace: true, state: { userLoggedOut: true } });
      dispatch({
        type: AUTH_API_LOGOUT,
      });
    });
  };

  return (
    <Box {...props} data-testid="logout-container">
      <IconButton
        color="primary"
        onClick={openMenu}
        data-testid="logout-icon-button"
      >
        <Power color="primary" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClick={closeMenu}
        onClose={closeMenu}
        PaperProps={{
          elevation: 0,
          rounded: "true",
          sx: {
            marginTop: 0,
            backgroundColor: (theme) => theme.palette.tertiary.background,
            top: "42px !important",
            overflow: "visible",
            ".MuiList-root": {
              padding: 0,
            },
          },
        }}
        data-testid="logout-menu"
      >
        <MenuItem
          color="secondary"
          sx={{
            "&.Mui-focusVisible": {
              backgroundColor: "inherit",
            },
          }}
          onClick={handleLogout}
          data-testid="logout-button"
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LogoutButton;
